import React from 'react';
import { Check } from 'lucide-react';

// Cyan square check + label (SPEC §7.1.2 checklist).
export default function CheckItem({ children }) {
  return (
    <li className="check-item">
      <span className="check-item__icon" aria-hidden="true">
        <Check size={15} strokeWidth={3} />
      </span>
      <span>{children}</span>
    </li>
  );
}
